module.exports = __webpack_public_path__ + "static/media/insect(9).00a9a00d.PNG";